import React, { FunctionComponent, useEffect, useState } from 'react';
import { Switch } from 'react-router-dom';
import MakeSubRoutes from './makeSubRoutes';
import { publicRoutes } from './routes';
import { buildDate } from '../utils/buildInfo';
import WebHeaderDetail from '../components/WebHeader/WebHeaderDetailPage';
import { handleBackApp, versionCheckFunction } from '../utils/apiConfig';
import useCustomHistory from '../hooks/useCustomHistory';
// declare let operatorapp: any;

const Public: FunctionComponent<any> = () => {
  const [webHeaderVersionShow, setWebHeaderVersionShow] = useState(false);
  let xAppVersion = sessionStorage['x-app-version:'];
  const { canGoBack, goBack } = useCustomHistory();
  const getUrlData = () => {
    const url = window.location.pathname;
    if (url === '/public/fleet-load-confirmation') {
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    const checkVer = versionCheckFunction(xAppVersion, '12.8.1');
    setWebHeaderVersionShow(checkVer);
  }, []);
  useEffect(() => {
    console.log('Build Code: ' + buildDate);
  }, []);

  useEffect(() => {
    getUrlData();
  }, []);

  return (
    <div>
      <Switch>
        <>
          {getUrlData() === true && webHeaderVersionShow && (
            <>
              <WebHeaderDetail
                onClick={() => handleBackApp(canGoBack, goBack)}
                className={'topHeaderTextClass'}
                mainContainerClass={'marketPlaceClass'}
              />
            </>
          )}
          {publicRoutes.map((route: object, index: number) => (
            <MakeSubRoutes key={index} {...route} />
          ))}
        </>
      </Switch>
    </div>
  );
};

export default Public;
